import React, { Component } from 'react';
import { getLoginUser } from '@/commons';
import { connect } from '@/models';
import { toLogin } from '@/commons';
import { UserAvatar } from '@/library/antd';
import './style.less';
import { Popover, Button } from 'antd';
//import Link from '../page-link';
//import {Link , Route} from 'react-router-dom';
import { ROUTE_BASE_NAME } from '@/router/AppRouter';
@connect(state => ({ local: state.system.i18n }))
export default class HeaderUser extends Component {
    static defaultProps = {
        theme: 'default',
    };
    state = {
        passwordVisible: false,
        aboutUsVisible: false,
        courseVisible: false,
        leavingMessageVisible: false,
        userName: this.props.local?.application?.name,
    };

    userCenter = () => {
        window.location.href = ROUTE_BASE_NAME + '/user-center';
        //console.log(this.props)
    };



    render() {
        const user = getLoginUser() || {};
        const name = user.name;
        const avatar = user.avatar;
        const content = (
            <div styleName="hedaer-user-menu">
                <p onClick={this.userCenter}>{this.props.local?.menu?.usercenter}</p>
                <p onClick={
                      ()=>{
                        toLogin();
                        window.localStorage.setItem('webInfo', '');
                      }}>
                {this.props.local?.menu?.logout}</p>
            </div >
        );
        return (
            // <Link to={{
            //     pathname: '/user-center',
            //     state: { from: 'menu' }
            // }}>
            //<Link to='/user-center'>
            <Popover content={content} >
                <div
                    // onClick={this.userCenter}
                    style={{ width: '100%', height: '98rem', margin: ' auto', textAlign: 'center', paddingTop: '30rem', marginBottom: '30rem' }}
                >

                    {avatar ? (
                        <UserAvatar style={{ cursor: 'pointer' }} size="large" src={avatar} />
                    ) : (
                        <UserAvatar style={{ cursor: 'pointer' }} size="large" name={name} />
                    )}
                    <div title={name} style={{ marginTop: '10rem', color: '#fff', fontSize: '13rem', fontWeight: 900, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{name}</div>

                </div>
            </Popover>
            //</Link>
        );
    }
}
